import styled from 'styled-components';

const ModalContent = styled.div`
  padding: 16px 32px;
  position: relative;
  font-size: ${({ theme }) => theme.text.size.medium};
`;

export default ModalContent;
